import React, { Component } from 'react';

import Background from '../../../components/background';
import PageContainer from '../../../components/pageContainer';

import ServiceClosedPage from '../../serviceClosed';
import UnauthenticatedFooter from '../unauthenticated/footer';

class ServiceClosedLayout extends Component {
  render = () => {
    return (
      <Background darkGrey>
        <PageContainer withFooter>
          <ServiceClosedPage />
        </PageContainer>

        <UnauthenticatedFooter />
      </Background>
    );
  };
}

export default ServiceClosedLayout;
